(function () {
  "use strict";

  var STORAGE_KEY = "market-choice";

  function isMobileSwitcher(root) {
    return root.getAttribute("data-variant") === "mobile";
  }

  function setMarketChoice(code) {
    if (!code) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, code.toLowerCase());
    } catch (e) {
      /* ignore */
    }
  }

  function parseMarketConfig(root) {
    var raw = root.getAttribute("data-market-config");
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function stripMarketPrefixes(path, prefixes) {
    var bare = path;
    var i;

    for (i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      if (!prefix) continue;
      if (bare === prefix || bare === prefix + "/") {
        return "/";
      }
      if (bare.indexOf(prefix + "/") === 0) {
        bare = bare.slice(prefix.length) || "/";
        break;
      }
    }

    return bare || "/";
  }

  function isOnMarketPrefix(path, prefix) {
    return path === prefix || path === prefix + "/" || path.indexOf(prefix + "/") === 0;
  }

  function buildMarketUrl(prefix, barePath, search) {
    var href;

    if (prefix) {
      if (barePath === "/") {
        href = prefix + "/";
      } else {
        href = prefix + barePath;
      }
    } else if (barePath === "/") {
      href = "/";
    } else {
      href = barePath;
    }

    if (search && href.indexOf("?") === -1) {
      href += search;
    }

    return href;
  }

  function getActiveMarketCode(pathname, markets) {
    var i;

    for (i = 0; i < markets.length; i++) {
      if (markets[i].pathPrefix && isOnMarketPrefix(pathname, markets[i].pathPrefix)) {
        return markets[i].countryCode;
      }
    }

    for (i = 0; i < markets.length; i++) {
      if (!markets[i].pathPrefix) {
        return markets[i].countryCode;
      }
    }

    return null;
  }

  function bindMarketLink(root, link) {
    link.addEventListener("click", function () {
      setMarketChoice(link.getAttribute("data-market-code"));
    });
  }

  function setCurrentItem(root, item, market, barePath, search) {
    var currentEl = item.querySelector(".bh-market-switcher__option--current");
    var link = item.querySelector("[data-market-link]");

    item.classList.add("is-current");
    item.setAttribute("aria-current", "true");

    if (link) {
      var span = document.createElement("span");
      span.className = "bh-market-switcher__option bh-market-switcher__option--current";
      span.innerHTML = link.innerHTML;
      link.replaceWith(span);
    } else if (currentEl) {
      return;
    }
  }

  function setAlternateItem(root, item, market, barePath, search) {
    var currentEl = item.querySelector(".bh-market-switcher__option--current");
    var code = item.getAttribute("data-market-code");

    item.classList.remove("is-current");
    item.removeAttribute("aria-current");

    if (currentEl) {
      var link = document.createElement("a");
      link.className = "bh-market-switcher__option";
      link.setAttribute("data-market-link", "");
      link.setAttribute("data-market-code", code);
      link.href = buildMarketUrl(market.pathPrefix || "", barePath, search);
      link.innerHTML = currentEl.innerHTML;
      currentEl.replaceWith(link);
      bindMarketLink(root, link);
      return;
    }

    var existingLink = item.querySelector("[data-market-link]");
    if (existingLink) {
      existingLink.href = buildMarketUrl(market.pathPrefix || "", barePath, search);
    }
  }

  function syncSwitcherFromLocation(root) {
    var markets = parseMarketConfig(root);
    if (!markets || !markets.length) return;

    var prefixes = markets
      .map(function (market) {
        return market.pathPrefix;
      })
      .filter(Boolean);
    var pathname = window.location.pathname;
    var search = window.location.search || "";
    var barePath = stripMarketPrefixes(pathname, prefixes);
    var activeCode = getActiveMarketCode(pathname, markets);
    var serverCurrent = root.querySelector(".bh-market-switcher__item.is-current");
    var serverCode = serverCurrent ? serverCurrent.getAttribute("data-market-code") : null;
    var list = root.querySelector(".bh-market-switcher__list");
    var activeMarket;
    var triggerLabel;
    var trigger;

    if (!list || !activeCode) return;

    activeMarket = markets.find(function (market) {
      return market.countryCode === activeCode;
    });

    if (!activeMarket) return;

    markets.forEach(function (market) {
      var item = list.querySelector('.bh-market-switcher__item[data-market-code="' + market.countryCode + '"]');
      if (!item) return;

      if (market.countryCode === activeCode) {
        setCurrentItem(root, item, market, barePath, search);
      } else {
        setAlternateItem(root, item, market, barePath, search);
      }
    });

    if (activeCode !== serverCode) {
      triggerLabel = root.querySelector(".bh-market-switcher__trigger-label");
      if (triggerLabel) {
        triggerLabel.textContent = activeMarket.label;
      }

      trigger = root.querySelector(".bh-market-switcher__trigger");
      if (trigger) {
        trigger.setAttribute("aria-label", "Select market, currently " + activeMarket.label);
      }
    }
  }

  function closeAllExcept(except) {
    document.querySelectorAll("[data-market-switcher]").forEach(function (root) {
      if (root === except) return;
      closeSwitcher(root);
    });
  }

  function closeSwitcher(root) {
    var trigger = root.querySelector(".bh-market-switcher__trigger");
    var panel = root.querySelector(".bh-market-switcher__panel");

    if (isMobileSwitcher(root)) {
      root.classList.remove("is-open");
      if (panel) {
        panel.setAttribute("aria-hidden", "true");
      }
    } else if (panel) {
      panel.hidden = true;
    }

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }
  }

  function openSwitcher(root) {
    var trigger = root.querySelector(".bh-market-switcher__trigger");
    var panel = root.querySelector(".bh-market-switcher__panel");

    closeAllExcept(root);

    if (isMobileSwitcher(root)) {
      root.classList.add("is-open");
      if (panel) {
        panel.setAttribute("aria-hidden", "false");
      }
    } else if (panel) {
      panel.hidden = false;
    }

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }
  }

  function initSwitcher(root) {
    if (root.dataset.marketSwitcherInit === "true") return;
    root.dataset.marketSwitcherInit = "true";

    syncSwitcherFromLocation(root);

    var trigger = root.querySelector(".bh-market-switcher__trigger");

    if (trigger) {
      trigger.addEventListener("click", function (e) {
        e.stopPropagation();
        var expanded = trigger.getAttribute("aria-expanded") === "true";
        if (expanded) {
          closeSwitcher(root);
        } else {
          openSwitcher(root);
        }
      });
    }

    root.querySelectorAll("[data-market-link]").forEach(function (link) {
      bindMarketLink(root, link);
    });
  }

  function init() {
    document.querySelectorAll("[data-market-switcher]").forEach(initSwitcher);

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-market-switcher]")) return;
      document.querySelectorAll("[data-market-switcher]").forEach(closeSwitcher);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      document.querySelectorAll("[data-market-switcher]").forEach(closeSwitcher);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-market-switcher]").forEach(initSwitcher);
  });
})();
